import styled from 'styled-components';

export const Container = styled.div`
  color: var(--white-color);
  /* background-image: url(${(props) => props.src});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover; */

  background: var(--second-color);
  margin: 0 auto;
  padding: 20px;
`;
export const ListBox = styled.div`
   margin: 10px auto;
  padding: 0;
  max-width: 1200px;

  font-size: 20px;
  color: var(--white-color);
  font-weight: 600;
  text-align: justify;

  
  h2 {
    font-size: 2.3rem;
    font-weight: 500;
    color: var(--white-color);
    word-wrap: break-word;
    margin-bottom: 10px;
  }
`;

export const QuotationBox = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 2rem;
  margin: 1.5rem 0;
  @media only screen and (min-width: 1000px) {
    align-items: center;
    flex-direction: row;
    align-items: stretch;
  }
`;

export const ImgBox = styled.div`
  padding: .5rem;
  background-color: rgba(0, 0, 0, 0.295);


  @media only screen and (min-width: 1000px) {
    width: 65%;
    margin: 0;
  }
  img {
    width: 100%;
    object-fit: cover;
    height: 500px;
  }
`;